import React, { useState } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default function ExcelTableManager() {
   const url = process.env.REACT_APP_URL_DIR + "sqlraw/sql";
   const token = localStorage.getItem("token");
   const [mensaje, setMensaje] = useState("");
   const [tableData, setTableData] = useState([]);

   const [input, setInput] = useState({
      tabla: "",
   });

   const [error, setError] = useState("");

   // ✅ Expected columns for validation
   const expectedColumns = ["id", "name", "age"];

   // 📥 Upload Excel handler
   const handleFileUpload = (e) => {
       var sql = "";
      setMensaje("");
      const file = e.target.files[0];
      if (!file) return;
      const reader = new FileReader();

      reader.onload = (event) => {
         const binaryStr = event.target.result;
         const workbook = XLSX.read(binaryStr, { type: "binary" });
         const sheetName = workbook.SheetNames[0];
         const sheet = workbook.Sheets[sheetName];
         const data = XLSX.utils.sheet_to_json(sheet, { defval: "" });
         // Validate columns
         if (data.length === 0) {
            setError("The Excel file is empty.");
            return;
         }

         setError("");
         setTableData(data);
         console.log('handleFileUpload: ', data);
         var columns = Object.keys(data[0]).join(", ");
         sql = `Insert into ${input.tabla} (${columns}) VALUES `;
         data.map((row) => {
         var values = Object.values(row).map((v) => `'${v}'`).join(", ");
             sql += `(${values}), `;
         });
         sql = sql.slice(0, -2) + ";";
         console.log(sql);


         setMensaje(sql);
      };
       reader.readAsBinaryString(file);
   };

   // 📤 Download Excel handler
   const exportToExcel = async () => {
    setMensaje("");
      var sql = `select * from ${input.tabla}`;
      console.log("input: ", input, sql);
      const response = await fetch(`${url}/${sql}`, {
         headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
         },
      });
      const data = await response.json();
      setTableData(data);
      console.log('tableData: ', tableData);

      const worksheet = XLSX.utils.json_to_sheet(tableData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
      const excelBuffer = XLSX.write(workbook, {
         bookType: "xlsx",
         type: "array",
      });
      const blob = new Blob([excelBuffer], {
         type: "application/octet-stream",
      });
      saveAs(blob, `input.${input.tabla}.xlsx`);
      setMensaje("Registros Grabados");
   };

   // 📘 Download template (only headers)
   const downloadTemplate = () => {
      const worksheet = XLSX.utils.json_to_sheet([
         Object.fromEntries(expectedColumns.map((c) => [c, ""])),
      ]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Template");
      const buffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      saveAs(
         new Blob([buffer], { type: "application/octet-stream" }),
         "template.xlsx"
      );
   };

   function handleChange(e) {
      e.preventDefault();
      setInput({
         ...input,
         [e.target.name]: e.target.value,
      });
   }
   return (
      <div
         style={{
            padding: "20px",
            fontFamily: "Arial, sans-serif",
            backgroundColor: "#a7bff0ff",
         }}
      >
         <h1 className="text-2xl font-semibold mb-4 text-center text-white">
            Excel Table Manager
         </h1>

         {/* Upload & Download controls */}
         <div
            style={{
               justifyContent: "space-between",
               alignItems: "center",
               marginBottom: "20px",
            }}
         >
            <div
               style={{ padding: "10px", fontWeight: "bold", color: "White" }}
            >
               <span style={{ fontWeight: "bold", color: "White" }}>
                  Tabla:{" "}
               </span>
               <input
                  type="text"
                  placeholder="Ingrese nombre de la tabla a exportar"
                  name="tabla"
                  value={input.tabla}
                  onChange={handleChange}
                  required
               />
            </div>
            <div
               style={{
                  //   display: "flex",
                  gap: "10px",
                  marginTop: "10px",
                  marginBottom: "10px",
                  alignItems: "center",
                  centerjustifyContent: "center",
               }}
            >
               <button
                  onClick={exportToExcel}
                  style={{
                     backgroundColor: "#2563eb",
                     color: "white",padding: "10px 20px",
                     borderRadius: "8px",
                     cursor: "pointer",
                  }}                  
               >
                  Download Excel
               </button>
               {/* &nbsp;&nbsp;
               <button
                  onClick={downloadTemplate}
                  style={{
                     backgroundColor: "#2563eb",
                     color: "white",padding: "10px 20px",
                     borderRadius: "8px",
                     cursor: "pointer",
                  }} 
               >
                  Download Template
               </button> */}
            </div>            <div>
               <label className="cursor-pointer bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded-lg transition">
                  <input
                     type="file"
                     accept=".xlsx, .xls"
                     onChange={handleFileUpload}
                     className="hidden"
                  />
                  &nbsp;Upload Excel
               </label>
            </div>

         </div>

         {error && (
            <div className="bg-red-100 text-red-700 px-4 py-2 rounded mb-4">
               ⚠️ {error}
            </div>
         )}

         {/* Table */}
         <div className="overflow-x-auto">
            <table className="w-full border border-gray-300 text-sm">
               <thead className="bg-gray-100">
                  <tr>
                        <th>
                           Resultado
                        </th>
                  </tr>
               </thead>
               <tbody>
                  {tableData && tableData.length > 0 ? (
                     <tr >
                        <td>
                           {mensaje} : {tableData.length}
                        </td>
                     </tr>
                  ) : (
                     <tr>
                        <td>No hay registros subidos.</td>
                     </tr>
                  )}
               </tbody>
            </table>
         </div>
      </div>
   );
}
